import EmptyCard from "../../components/EmptyCard/EmptyCard.jsx";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import React from "react";
import { connect } from 'react-redux';
import { getSystemsForGroup } from '../../stores/actions/actions';
import { clearDashboardData, getVisibleSystemGroups } from '../../stores/actions/dashboardActions';
import ErrorText from '../../components/ErrorComponent/ErrorText';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';
import SystemSearchBar from './SystemSearchBar'
import ShortStatusContet from '../../components/ShortStatus/ShortStatusContet';
import { loaderStyleEmptyCard } from '../../helpers/CustomStyles';
import SystemGroupMap from "../../components/SystemGroupMap/SystemGroupMap";
import _ from 'lodash';

class DashboardSystemGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      invalidParam: false,
    }
    this.groupId = null;
    this.invalidParam = false;
    this.name = '';
    this.systemsCount = 0;
    this.props.clearDashboardData();
    this.props.getVisibleSystemGroups();
    this.renderEmptyMessage = this.renderEmptyMessage.bind(this);
    const param = this.props.match?.params?.id;
    if (param) {
        const systemGroupId = parseInt(param);
        if (!isNaN(systemGroupId)) {
            this.props.getSystemsForGroup(systemGroupId);
        } else {
            this.invalidParam = true;
        }
        this.groupId = systemGroupId;
        this.name = this.props.systemGroups?.filter(g => g.ID === systemGroupId)[0].name;
        this.systemsCount =  this.props.systemGroups?.filter(g => g.ID === systemGroupId)[0].systemsCount;
    }
  }

  renderSystemSearchBar = () => {
    if (!this.props.systems?.length) return null;
    return <SystemSearchBar systems={this.props.systems}/>
  }

  render() {
    const { classes, mobileView, forbidden, groupId } = this.props;
    if (this.invalidParam || forbidden) {
      return <div  style={{ padding: "10px", ...loaderStyleEmptyCard }}>403</div>;
    }
    try {
      let content;
      let header;
      const { dashboardFilteredSystemsNames, systems } = this.props;

      header = <GridItem xs={12} sm={12} md={12} lg={12}><h3>{this.name}</h3></GridItem>;
      if (systems?.length >= 1 && groupId === this.groupId) {

        content = systems.map((system, i) => {
          const filteredSystem = dashboardFilteredSystemsNames?.find(filteredSystem => filteredSystem === system.name)
          if (!filteredSystem && dashboardFilteredSystemsNames?.length) return null;
          return (
            <GridItem xs={12} sm={6} md={4} lg={4} key={"grid-item-" + i}
              style={{ padding: mobileView ? '0 15px;' : (i+2)%3 ? '0 15px' : '0 7px'}}
            >
              <ShortStatusContet
                linkDisabled={false}
                key={i + "-short-status"}
                classes={classes}
                system={system}
                showSmallWeatherCard={true}
              />
            </GridItem>
          )
        });
      } else {
        content = this.renderEmptyMessage(classes)
      }

      return (
        <ErrorComponent message='Corrupted systems data.' children>
          <GridContainer data-testid="DashboardSystemGroup">
            {this.renderSystemSearchBar()}
            {header}
            <SystemGroupMap systems={systems} groupId={this.groupId} systemsCount={this.systemsCount}/>
            {content}
          </GridContainer>
        </ErrorComponent>
      );
    } catch (error) {
      console.log(error)
      return (
        <ErrorText message='Corrupted systems data.'></ErrorText>
      )
    }
  }

  renderEmptyMessage(classes) {
    return <EmptyCard classes={classes} accountCategory={this.props.accountCategory} />
  }
}

const mapStateToProps = (state) => {
  return {
    systems: state.dashboard.systemsForGroup,
    groupId: state.dashboard.groupId,
    systemGroups: state.dashboard.systemGroups,
    accountCategory: state.dashboard.accountCategory,
    dashboardFilteredSystemsNames: state.dashboard.dashboardFilteredSystemNamesForGroup ?? [],
    mobileView: state.dashboard.mobileView,
    forbidden: state.dashboard.forbidden,
  }
}
const actions = {
  getSystemsForGroup,
  getVisibleSystemGroups,
  clearDashboardData
}

export default connect(mapStateToProps, actions)(DashboardSystemGroup);